import RefundView from '@/template/views/RefundView.vue';
export var routes = [
    {
        name: 'refundRequest',
        path: '/refundRequest/:id',
        component: RefundView,
        meta: {
            mainNav: false,
            title: 'Forms.RefundRequest',
            type: 'RefundRequest'
        }
    },
    {
        name: 'claimForRecovery',
        path: '/claimForRecovery/:id',
        component: RefundView,
        meta: {
            mainNav: false,
            title: 'Forms.ClaimForRecovery',
            type: 'ClaimForRecovery'
        }
    }
];
